import Request from './config'
import type { AxiosResponse } from 'axios'
import { encrypt, resDecode, apiReName } from '@/utils/apiCrypto'
import { getWebX7syDev } from '@/utils/headers'
import _localStorage from '@/utils/storage'
import x7url from '@/utils/x7url'

let baseURL = `https://${x7url.getServerHost('upload')}`

if (import.meta.env.DEV) {
  baseURL = '/uploadPhp'
}

const request = new Request({
  baseURL,
  timeout: 30000, // 请求超时时间
  withCredentials: true, // 是否允许带cookie这些
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  interceptors: {
    // 请求拦截器
    requestInterceptors: (config) => {
      console.log('config', JSON.parse(JSON.stringify(config)))
      config.headers['Web-X7sy-Dev'] = getWebX7syDev() // web请求标识
      config.headers['X7-Debug-Token'] = _localStorage.get('X7-Debug-Token') ?? ''
      if (import.meta.env.VITE_X7_REQ_ENV) {
        config.headers['X7-Req-Env'] = import.meta.env.VITE_X7_REQ_ENV
        config.headers['X7-Req-Hash'] = '0e188196e2ab6e9b3a8f22873ebc0778' // 目前是固定写死的
      } else {
        delete config.headers['X7-Req-Env']
        delete config.headers['X7-Req-Hash']
      }
      config.url = apiReName(config.url || '', 'fm/')
      config.data = encrypt(config.data)
      config.params = encrypt(config.params)
      return config
    },
    // 响应拦截器
    responseInterceptors: <T extends AxiosResponse>(result: T): T => {
      result.data = result.data && typeof result.data === 'string' ? <T>resDecode(result.data) : result
      return result
    },
    responseInterceptorsCatch: (error: any) => {
      const data = error?.response?.data ? resDecode(error.response?.data) : error
      return Promise.reject(data)
    }
  }
})

export default request.instance
